import {Style,  RegularShape, Fill, Stroke} from 'ol/style';

import regular from './regular.js'

export const triangle = async (styleDef,layer,__style) => {
	var __layer = Object.assign({},layer);
	__layer.point = 3;
	return await regular(styleDef, __layer, __style);
};

export  default triangle;